import React from 'react';
import { Menu, Divider, Button, Box, styled } from '@mui/material';
import { DateRangePicker, Range, RangeKeyDict } from 'react-date-range';
import { IWithClassName } from '../../theme/default.theme';

interface IProps extends IWithClassName{
    openDatePicker: HTMLElement | null;
    setDatePicker: (value: HTMLElement | null) => void;
    datePickerRange: Array<Range>;
    dateHandler: (value: RangeKeyDict) => void;
}

const DatePicker = ({openDatePicker, setDatePicker, datePickerRange, dateHandler, className}:IProps) => (
    <Menu anchorEl={openDatePicker} open={Boolean(openDatePicker)} onClose={() => setDatePicker(null)} className={className}>
        <DateRangePicker
            onChange={dateHandler}
            moveRangeOnFirstSelection={false}
            months={2}
            ranges={datePickerRange}
            direction="horizontal"
            preventSnapRefocus={true}
            calendarFocus="backwards"
        />
        <Divider />
        <Box className="action-bar">
            <Button
                onClick={() => setDatePicker(null)}
                variant="contained"
                color="primary"
                size="small"
            >
                Done
            </Button>
        </Box>
    </Menu>
);

export default styled(DatePicker)(() => ({
    ".action-bar": {
        display: "flex",
        justifyContent: "flex-end",
        padding: "8px",
    }
}));